module.exports = __webpack_public_path__ + "img/hong.bf96dbcc.png";